import {
  createApiFactory,
  createPlugin,
  createRoutableExtension,
  configApiRef,
  githubAuthApiRef,
} from '@backstage/core-plugin-api';
import { catalogApiRef } from '@backstage/plugin-catalog-react';

import { engagementApiRef, EngagementClient } from './api';
import { rootRouteRef } from './routes';

export const engagementTrackerPlugin = createPlugin({
  id: 'engagement-tracker',
  apis: [
    createApiFactory({
      api: engagementApiRef,
      deps: {
        catalogApi: catalogApiRef,
        configApi: configApiRef,
        githubAuthApi: githubAuthApiRef,
      },
      factory: ({ catalogApi, configApi, githubAuthApi }) =>
        EngagementClient.fromConfig({ catalogApi, configApi, githubAuthApi }),
    }),
  ],
  routes: {
    root: rootRouteRef,
  },
});

export const EngagementTrackerPage = engagementTrackerPlugin.provide(
  createRoutableExtension({
    name: 'EngagementTrackerPage',
    component: () =>
      import('./components/EngagementTracker').then(m => m.EngagementTracker),
    mountPoint: rootRouteRef,
  }),
);
